import { IBaseAction } from '../../../../common/interfaces/IBaseAction';
export enum Keys {

	ADDCHATMESSAGE = 'react/chat/ADDCHATMESSAGE',
	ADDCHATMESSAGE_FULFILLED = 'react/chat/ADDCHATMESSAGE_FULFILLED',
	ADDCHATMESSAGE_REJECTED = 'react/chat/ADDCHATMESSAGE_REJECTED',

	GETCHATMESSAGES = 'react/chat/GETCHATMESSAGES',
	GETCHATMESSAGES_FULFILLED = 'react/chat/GETCHATMESSAGES_FULFILLED',
	GETCHATMESSAGES_REJECTED = 'react/chat/GETCHATMESSAGES_REJECTED',

	SETASSEEN = 'react/chat/SETASSEEN',
	SETASSEEN_FULFILLED = 'react/chat/SETASSEEN_FULFILLED',
	SETASSEEN_REJECTED = 'react/chat/SETASSEEN_REJECTED',

	GETCHATUNREADCOUNT = 'react/chat/GETCHATUNREADCOUNT',
	GETCHATUNREADCOUNT_FULFILLED = 'react/chat/GETCHATUNREADCOUNT_FULFILLED',
	GETCHATUNREADCOUNT_REJECTED = 'react/chat/GETCHATUNREADCOUNT_REJECTED',

	RECEIVEMESSAGEWEBSOCKET = 'react/chat/RECEIVEMESSAGEWEBSOCKET',	
	
	RESETNEWMESSAGERECEIVEDSTATUS = 'react/chat/RESETNEWMESSAGERECEIVEDSTATUS',	
	SETNEWMESSAGERECEIVEDSTATUS = 'react/chat/SETNEWMESSAGERECEIVEDSTATUS',	

	OTHER_ACTION = 'react/chat/__any_other_action__'
}

export type Types = IBaseAction<Keys>;